import { render, staticRenderFns } from "./supplyPrice.vue?vue&type=template&id=06307fe5&scoped=true"
import script from "./supplyPrice.vue?vue&type=script&lang=js"
export * from "./supplyPrice.vue?vue&type=script&lang=js"
import style0 from "./supplyPrice.vue?vue&type=style&index=0&id=06307fe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06307fe5",
  null
  
)

export default component.exports